import { render, staticRenderFns } from "./ProductsTableConservation.vue?vue&type=template&id=e0e85270&"
import script from "./ProductsTableConservation.vue?vue&type=script&lang=js&"
export * from "./ProductsTableConservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports